import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

// Loyalty checklist screen
import { LoyaltyPointsChecklistScreen } from '../../screens/checklists/LoyaltyPointsChecklistScreen';

// Loyalty Point screens
import { LoyaltyPointIntroScreen } from '../../screens/tasks/loyalty/LoyaltyPointIntroScreen';
import { LoyaltyPointDashboardScreen } from '../../screens/tasks/loyalty/LoyaltyPointDashboardScreen';
import { LoyaltyPointInputScreen } from '../../screens/tasks/loyalty/LoyaltyPointInputScreen';
import { LoyaltyPointDataScreen } from '../../screens/tasks/loyalty/LoyaltyPointDataScreen';

const Stack = createNativeStackNavigator();

const LoyaltyStackNavigator: React.FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      {/* Main Loyalty Checklist */}
      <Stack.Screen name="LoyaltyPointsChecklist" component={LoyaltyPointsChecklistScreen} />

      {/* Loyalty Point Screens */}
      <Stack.Screen name="LoyaltyPointIntroScreen" component={LoyaltyPointIntroScreen} />
      <Stack.Screen name="LoyaltyPointDashboardScreen" component={LoyaltyPointDashboardScreen} />
      <Stack.Screen name="LoyaltyPointInputScreen" component={LoyaltyPointInputScreen} />
      <Stack.Screen name="LoyaltyPointDataScreen" component={LoyaltyPointDataScreen} />
    </Stack.Navigator>
  );
};

export default LoyaltyStackNavigator;